import Image from "next/image";
import { Stack, GridItem, SimpleGrid } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text, Heading } from "@/elements";
import { EXTEND_CONSTANTS } from "./constants";

const ExtendComponent = () => {
  const TextVariant = useTextVariant();
  const { title, image, desc } = EXTEND_CONSTANTS;
  return (
    <Stack pr={{ md: 16 }} gap={8} border="1px solid #9ECFFF" pt={8} bgColor={"#F9FAFC"}>
      <SimpleGrid gridTemplateColumns={{ base: "1fr", sm: "0.75fr 1fr" }} gap={8}>
        <GridItem pt={8}>
          <Image
            src={image}
            alt="Kubernetes"
            width={500}
            height={350}
            style={{ transform: "rotate(-30deg)" }}
          />
        </GridItem>
        <GridItem
          width={{ base: "100%", sm: "90%" }}
          alignSelf={"center"}
          p={{ base: 4, md: 0 }}
        >
          <Stack gap={8}>
            <Heading as="h2" fontWeight={"400"} fontSize={"40px"}>
              {title}
            </Heading>
            <Text variant={TextVariant} color="text.100">
              {desc}
            </Text>
          </Stack>
        </GridItem>
      </SimpleGrid>
    </Stack>
  );
};

export default ExtendComponent;
